var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-left-legend-item"},[_c('ScreenUserIcon',{staticClass:"bottom-left-legend-badge",attrs:{"color":_vm.color}}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }